import {EtsyList, EtsyListing, GetEtsyListingsByShopParams} from '@coolcolduk/etsy';
import {useEffect, useState} from 'react';
import getAxios from '../util/axios/getAxios';
import withFirebaseToken from '../util/firebase/withFirebaseToken';

/**
 * Fetch listings by shop using the Axios client.
 * @param token - token for our api
 * @param accessToken - etsy access token
 * @param shopId - shop to fetch data from
 * @param params - Query parameters for the API.
 * @returns The listings response.
 */
export const fetchListingsByShop = async (
  token: string,
  shopRecordId: string,
  params: GetEtsyListingsByShopParams,
): Promise<EtsyList<EtsyListing>> => {
  const response = await getAxios('etsy', {token}).get<EtsyList<EtsyListing>>(`getListingsByShop`, {
    params: {
      ...params,
      shopRecordId,
    },
  });

  return response.data;
};

export const useGetListingsByShop = (shopRecordId?: string, params: GetEtsyListingsByShopParams = {}) => {
  const [data, setData] = useState<EtsyList<EtsyListing> | undefined>(undefined);

  useEffect(() => {
    withFirebaseToken(async (token) => {
      if (!token || !shopRecordId) {
        setData(undefined);
        return;
      }
      setData(await fetchListingsByShop(token, shopRecordId, params));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params), shopRecordId]);

  return data;
};
